import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTheme } from 'styled-components'

import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { StLink } from './ExternalLink.styled'

import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import type { ComponentPropsWithoutRef } from 'react'

type ExternalLinkProps = {
  icon?: IconProp
} & ComponentPropsWithoutRef<'a'>

export const ExternalLink = ({ icon, children, ...props }: ExternalLinkProps) => {
  const theme = useTheme()
  return (
    <StLink {...props}>
      {icon ? <FontAwesomeIcon icon={icon} /> : null}

      <P type='BodyMediumBold' color={theme.Colors.Theme.Primary}>
        {children}
      </P>
    </StLink>
  )
}
